// Custom.
import { GeneralObject } from "@vocollege/app/dist/global";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { getUserString } from "@vocollege/app/dist/modules/VoHelpers";
import {
  DownloadExcelButtonProps,
  Sheet,
} from "@vocollege/components/dist/DownloadExcelButton";

export const getCourseMomentsParticipants = (rawData: any) => {
  if (rawData.length === 0) {
    return 0;
  }
  return rawData.reduce(
    (acc: any, v: GeneralObject) => acc + v.participants.length,
    0
  );
};

export const getExcelData = (data: any, parsedData: any, variables: any) => {
  if (parsedData.length === 0 || !data) {
    return null;
  }
  const result: DownloadExcelButtonProps = {
    filename: I18n.get.vocertCourseMoment.label,
    sheets: [],
  };
  let commonHead = [
    [
      {
        richText: [
          {
            font: {
              size: 16,
              bold: true,
            },
            text: I18n.get.vocertCourseMoment.labels.courseMoments,
          },
        ],
      },
      "",
      `${I18n.get.misc.created_at} ${data.certStatisticsCourseMoments.createdAt}\n${variables?.from} - ${variables?.to}`,
    ],
    [""],
    [],
    [
      {
        richText: [
          {
            font: {
              size: 10,
              bold: true,
            },
            text: I18n.get.vocertStatistics.total,
          },
        ],
      },
      "",
      parsedData.length,
    ],
    [
      {
        richText: [
          {
            font: {
              size: 10,
              bold: true,
            },
            text: I18n.get.participant.labels.participants,
          },
        ],
      },
      "",
      getCourseMomentsParticipants(parsedData),
    ],
  ];

  let byGroupSheet: Sheet = {
    name: I18n.get.vocertStatistics.summary,
    rows: [...commonHead],
  };

  parsedData.forEach((v: GeneralObject) => {
    byGroupSheet.rows?.push(["", "", ""]);
    let title = v.title;
    if (v.note) {
      title = `${title}\n${v.note}`;
    }
    if (v.author_email) {
      byGroupSheet.rows?.push([
        {
          richText: [
            {
              font: {
                size: 10,
                bold: true,
              },
              text: title,
            },
          ],
        },
        "",
        getUserString({
          firstname: v.author_firstname,
          lastname: v.author_lastname,
          email: v.author_email,
        }),
      ]);
    }
    byGroupSheet.rows?.push([
      "",
      "",
      `${I18n.get.vocertMisc.when}: ${v.start_date} - ${v.end_date}`,
    ]);
    byGroupSheet.rows?.push([
      "",
      "",
      `${I18n.get.group.categories.local}: ${
        v.college_title || I18n.get.misc.notVoCollege
      }`,
    ]);
    byGroupSheet.rows?.push([
      "",
      "",
      `${I18n.get.participant.labels.participants}: ${v.participants_count}`,
    ]);
    byGroupSheet.rows?.push([
      "",
      "",
      `${I18n.get.form.labels.items}: ${v.course_moment_items_count}`,
    ]);
  });

  result.sheets?.push(byGroupSheet);

  return result;
};

export const getCourseMomentsCsvData = (rawData: any) => {
  const result: GeneralObject[] = [];
  result.push({
    description: I18n.get.vocertStatistics.total,
    value: rawData.length,
  });
  result.push({
    description: I18n.get.participant.labels.participants,
    value: getCourseMomentsParticipants(rawData),
  });
  rawData.forEach((v: GeneralObject) => {
    result.push({
      description: v.title,
      value: "",
    });
    result.push({
      description: `    ${getUserString({
        firstname: v.author_firstname,
        lastname: v.author_lastname,
        email: v.author_email,
      })}`,
      value: "",
    });
    result.push({
      description: `    ${v.start_date} - ${v.end_date}`,
      value: "",
    });
    result.push({
      description: `    ${v.college_title || I18n.get.misc.notVoCollege}`,
      value: "",
    });
  });
  return result;
};
